import { SafeTag, Likert } from '@itau-loans-www/components'

import Layout from '../../layouts/Summary'
import '../final-screen.scss'
import './fgts-partner-ineligible.scss'

const FgtsPartnerIneligible = () => {
  return (
    <Layout>
      <div className="final_screen">
        <SafeTag />
        <div className="final_screen__content">
          <h1 className="final_screen__title --fgts">
            Não identificamos uma oferta de Saque Aniversário disponível para
            você
          </h1>
        </div>
        <div className="fgts-partner-ineligible">
          <p className="fgts-partner-ineligible__info">
            O Saque Aniversário está disponível apenas para aqueles que possuem
            uma conta ativa no Fundo de Garantia do Tempo de Serviço.
            <br />
            <br />
            Para ser elegível, é necessário ter um saldo disponível suficiente
            no FGTS
          </p>
        </div>
        <Likert />
      </div>
    </Layout>
  )
}

export default FgtsPartnerIneligible
